import { render, staticRenderFns } from "./v20a6000pcDockBatch.vue?vue&type=template&id=17981ca8&"
import script from "./v20a6000pcDockBatch.vue?vue&type=script&lang=js&"
export * from "./v20a6000pcDockBatch.vue?vue&type=script&lang=js&"
import style0 from "./v20a6000pcDockBatch.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports